

































































































































import { defineComponent, reactive, computed, ref } from "@vue/composition-api";
import { getStore } from "../store";
import { useRouter } from "../router";
import { useI18n } from "../i18n";
import { useClientChecker } from "../client-checker";

const componentName = "SignIn";

export default defineComponent({
	name: componentName,

	setup(context) {
		const store = getStore(),
			{ router, route } = useRouter(),
			client = useClientChecker(),
			i18n = useI18n();

		const state = reactive({
			signInErrorNotification: false,
			signInProgress: false,
			useExternalSigninMethods:
				!client.clientIsToolbox.value && !client.clientIsYou.value,
			useExternalSigninMethodGoogle: true,
			useExternalSigninMethodFacebook: true,
			useExternalSigninMethodApple: false,
		});

		const form = reactive({
			email: "",
			password: "",
			impersonateUsername: null,
		});

		const introTitle = ref("");
		const showNotification = ref(false);

		const impersonate = computed(() => !!route.value.query.impersonate);

		if (
			client.clientIsGoogleBliss.value ||
			client.clientIsGoogleYesly.value ||
			client.clientIsGoogleYou.value
		) {
			introTitle.value = <string>i18n.t("accessSignInIntroGoogleTitle");
			showNotification.value = true;
		}
		// else if (client.clientIsAlexaBliss.value || client.clientIsAlexaYesly.value || client.clientIsAlexaYou.value) {
		//     introTitle.value = <string>i18n.t('accessSignInIntroAlexaTitle');
		//     showNotification.value = true;
		// }
		else {
			introTitle.value = <string>i18n.t("accessSignInIntroGenericTitle");
		}

		const onSignIn = async () => {
			state.signInErrorNotification = false;
			state.signInProgress = true;

			let args = {
				clientId: route.value.query.client_id,
				returnUrl: route.value.query.returnUrl,
				username: form.email.trim(),
				password: form.password,
				language: route.value.query.language,
				impersonateUsername: form.impersonateUsername,
			};

			let res = route.value.query.returnUrl
				? await store.dispatch("signInOidc", args)
				: await store.dispatch("signIn", args);

			state.signInProgress = false;

			if (res) {
				if (res.next) {
					window.location.assign(res.next);
				} else {
					router.push({ name: "user-dashboard" });
				}
			} else {
				state.signInErrorNotification = true;
			}
		};

		const onSignInGoogle = () => {
			window.location.assign(
				`/account/signin-external-google${window.location.search}`
			);
		};

		const onSignInFacebook = () => {
			window.location.assign(
				`/account/signin-external-facebook${window.location.search}`
			);
		};

		const onSignInApple = () => {
			window.location.assign(`/account/signin-external-apple${window.location.search}`);
		};

		const passwordRecoveryRoute = computed(() => {
			return { name: "access-password-recovery", query: route.value.query };
		});

		const registerRoute = computed(() => {
			return { name: "access-register", query: route.value.query };
		});

		const submitEnabled = computed(() => {
			return !!form.email && !!form.password;
		});

		return {
			state,
			form,
			onSignIn,
			onSignInGoogle,
			onSignInFacebook,
			onSignInApple,
			introTitle,
			showNotification,
			passwordRecoveryRoute,
			registerRoute,
			submitEnabled,
			impersonate,
		};
	},
});
